@if (data) {
  @if (data.link) {
    @switch (data.link.type) {
      @case (linkTypes.ROUTER) {
        <a class="card-container" [routerLink]="data.link.url">
          <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
        </a>
      }
      @case (linkTypes.PROGRAMMATIC) {
        <a class="card-container" (click)="linkAction($event)">
          <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
        </a>
      }
      @case (linkTypes.EXTERNAL) {
        <a class="card-container" [href]="data.link.url" [target]="data.link.target">
          <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
        </a>
      }
      @case (linkTypes.NONE) {
        <div class="card-container">
          <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
        </div>
      }
    }
  } @else {
    @switch (layout) {
      @case (cardLayout.HERO) {
        <mb-card-hero [data]="data" [alignContent]="alignContent" [fuelLabelPosition]="fuelLabelPosition">
          <ng-container media>
            <ng-container *ngTemplateOutlet="mediaTpl"></ng-container>
            @if (data.type === pressKitCardType) {
              <span class="press-kit-flag hero-flag copy-s">
                {{ 'PRESS_KIT' | translate }}
              </span>
            }
          </ng-container>
          <ng-container action-container *ngTemplateOutlet="actionContainerTpl"></ng-container>
        </mb-card-hero>
      }
      @case (cardLayout.ROW) {
        <mb-card-row [data]="data" [alignContent]="alignContent" [fuelLabelPosition]="fuelLabelPosition">
          <ng-container media>
            <ng-container *ngTemplateOutlet="mediaTpl"></ng-container>
            @if (data.type === pressKitCardType) {
              <span class="press-kit-flag row-flag copy-s">
                {{ 'PRESS_KIT' | translate }}
              </span>
            }
          </ng-container>
          <ng-container action-container *ngTemplateOutlet="actionContainerTpl"></ng-container>
        </mb-card-row>
      }
      @case (cardLayout.COLUMN) {
        <mb-card-column [data]="data" [alignContent]="alignContent" [fuelLabelPosition]="fuelLabelPosition">
          <ng-container media>
            <ng-container *ngTemplateOutlet="mediaTpl"></ng-container>
            @if (data.type === pressKitCardType) {
              <span class="press-kit-flag copy-s">
                {{ 'PRESS_KIT' | translate }}
              </span>
            }
          </ng-container>
          <ng-container action-container *ngTemplateOutlet="actionContainerTpl"></ng-container>
        </mb-card-column>
      }
    }
  }
  <ng-template #cardTemplate>
    @switch (layout) {
      @case (cardLayout.HERO) {
        <mb-card-hero [data]="data" [alignContent]="alignContent" [fuelLabelPosition]="fuelLabelPosition">
          <ng-container media>
            <ng-container *ngTemplateOutlet="mediaTpl"></ng-container>
            @if (data.type === pressKitCardType) {
              <span class="press-kit-flag hero-flag copy-s">
                {{ 'PRESS_KIT' | translate }}
              </span>
            }
          </ng-container>
          <ng-container action-container *ngTemplateOutlet="actionContainerTpl"></ng-container>
        </mb-card-hero>
      }
      @case (cardLayout.ROW) {
        <mb-card-row [data]="data" [alignContent]="alignContent" [fuelLabelPosition]="fuelLabelPosition">
          <ng-container media>
            <ng-container *ngTemplateOutlet="mediaTpl"></ng-container>
            @if (data.type === pressKitCardType) {
              <span class="press-kit-flag row-flag copy-s">
                {{ 'PRESS_KIT' | translate }}
              </span>
            }
          </ng-container>
          <ng-container action-container *ngTemplateOutlet="actionContainerTpl"></ng-container>
        </mb-card-row>
      }
      @case (cardLayout.COLUMN) {
        <mb-card-column [data]="data" [alignContent]="alignContent" [fuelLabelPosition]="fuelLabelPosition">
          <ng-container media>
            <ng-container *ngTemplateOutlet="mediaTpl"></ng-container>
            @if (data.type === pressKitCardType) {
              <span class="press-kit-flag copy-s">
                {{ 'PRESS_KIT' | translate }}
              </span>
            }
          </ng-container>
          <ng-container action-container *ngTemplateOutlet="actionContainerTpl"></ng-container>
        </mb-card-column>
      }
    }
  </ng-template>
  <ng-template #mediaTpl>
    <ng-content select="figure"></ng-content>
  </ng-template>
}

<ng-template #actionContainerTpl>
  @if (actions && actions.length) {
    <mb-action-container
      [buttonItems]="actions"
      [resource]="data"
      (actionClick)="actionClick.emit($event)"
    ></mb-action-container>
  }
</ng-template>
